import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, vModelText as _vModelText, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/camera.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-f29ef568")

_pushScopeId("data-v-f29ef568")
const _hoisted_1 = { class: "container promo-container" }
const _hoisted_2 = { class: "shape-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "several-section" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "default-title fs-16" }
const _hoisted_10 = { class: "default-text" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = {
  key: 0,
  class: "status-green"
}
const _hoisted_17 = {
  key: 1,
  class: "status-red"
}
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "default-title" }
const _hoisted_21 = { class: "default-text" }
const _hoisted_22 = { class: "position-relative" }
const _hoisted_23 = {
  key: 1,
  class: "row"
}
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = { class: "default-title" }
const _hoisted_26 = { class: "default-text" }
const _hoisted_27 = { class: "position-relative" }
const _hoisted_28 = {
  key: 2,
  class: "row"
}
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "default-title" }
const _hoisted_31 = { class: "default-text" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "default-title" }
const _hoisted_34 = { class: "default-text" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "default-title" }
const _hoisted_38 = { class: "default-text" }
const _hoisted_39 = { class: "invalid-feedback" }
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "default-title" }
const _hoisted_43 = { class: "default-text" }
const _hoisted_44 = { class: "invalid-feedback" }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_46 = { class: "row" }
const _hoisted_47 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-6 default-title" }
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-earth-shape fs-20" }, null, -1)
const _hoisted_51 = { class: "default-text" }
const _hoisted_52 = { class: "input-text-length" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("/60 ")
const _hoisted_54 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-6 default-title" }, "Url:")
], -1)
const _hoisted_56 = { class: "default-text" }
const _hoisted_57 = { class: "input-text-length" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("/2000 ")
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "image-container" }
const _hoisted_61 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_62 = { class: "text-center" }
const _hoisted_63 = { class: "default-title" }
const _hoisted_64 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_65 = { class: "image-container" }
const _hoisted_66 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_67 = { class: "text-center" }
const _hoisted_68 = { class: "default-title" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "footer-space" }, null, -1)
const _hoisted_70 = { class: "product-edit-container" }
const _hoisted_71 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_72 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_73 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_74 = {
  type: "submit",
  class: "order-modify-button-wrapper btn-green",
  form: "promoForm"
}
const _hoisted_75 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-save fs-20" }, null, -1)
const _hoisted_76 = { class: "my-1" }
const _hoisted_77 = /*#__PURE__*/_createVNode("i", { class: "arrow up" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('title.promo' + _ctx.PromotedType[_ctx.promotedType])), 1)
    ]),
    _createVNode("form", {
      novalidate: "",
      id: "promoForm",
      onSubmit: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('label.promoPosition')) + ":", 1),
                _createVNode("div", _hoisted_10, [
                  (_ctx.promoProduct.order)
                    ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.promoProduct.order), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.promoCounter + 1), 1))
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                (_ctx.promoProduct.order)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _withDirectives(_createVNode("input", {
                          type: "checkbox",
                          class: "toggle",
                          checked: _ctx.promoProduct.active,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.promoProduct.active = $event))
                        }, null, 8, ["checked"]), [
                          [_vModelCheckbox, _ctx.promoProduct.active]
                        ]),
                        _createVNode("div", null, [
                          (_ctx.promoProduct.active)
                            ? (_openBlock(), _createBlock("span", _hoisted_16, "ACTIVE"))
                            : (_openBlock(), _createBlock("span", _hoisted_17, "NOT ACTIVE"))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.promotedType != _ctx.PromotedType.UpperBanner)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('promo.providerName')) + ":", 1),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, [
                        _createVNode(_component_Multiselect, _mergeProps({
                          class: { 'form-controll-multiselect': !_ctx.promoProduct.providerId },
                          modelValue: _ctx.promoProduct.providerId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.promoProduct.providerId = $event))
                        }, _ctx.providerSelect, { onChange: _ctx.providerChanged }), null, 16, ["class", "modelValue", "onChange"]),
                        (_ctx.promoProduct.providerId)
                          ? (_openBlock(), _createBlock("i", {
                              key: 0,
                              class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.promoProduct.providerId = 0))
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.promotedType != _ctx.PromotedType.UpperBanner)
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('product.productName')) + ":", 1),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: _ctx.promoProduct.productId,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.promoProduct.productId = $event))
                        }, _ctx.productSelect, {
                          options: _ctx.filteredProducts,
                          onInput: _ctx.getProductImg
                        }), null, 16, ["modelValue", "options", "onInput"]),
                        (_ctx.promoProduct.productId)
                          ? (_openBlock(), _createBlock("i", {
                              key: 0,
                              class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.promoProduct.productId = 0))
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.promotedType != _ctx.PromotedType.UpperBanner)
              ? (_openBlock(), _createBlock("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('promo.price')) + ":", 1),
                    _createVNode("div", _hoisted_31, [
                      _withDirectives(_createVNode("input", {
                        type: "number",
                        step: "0.01",
                        class: "bookit-input form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.promoProduct.price = $event)),
                        maxlength: "10",
                        onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkPriceLength && _ctx.checkPriceLength(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.promoProduct.price]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _createVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('priceList.currency')) + ":", 1),
                    _createVNode("div", _hoisted_34, [
                      _createVNode(_component_Multiselect, _mergeProps({
                        modelValue: _ctx.promoProduct.currencyId,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.promoProduct.currencyId = $event))
                      }, _ctx.currenciesSelect), null, 16, ["modelValue"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('promo.fromDate')) + ":", 1),
                _createVNode("div", _hoisted_38, [
                  _createVNode(_component_Calendar, {
                    class: { 'form-controll-multiselect': !_ctx.dateRange.fromDate },
                    ref: "calendar",
                    minDate: new Date(),
                    onDateSelect: _ctx.dateChanged,
                    modelValue: _ctx.dateRange.fromDate,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dateRange.fromDate = $event)),
                    selectionMode: "single",
                    dateFormat: "dd/mm/yy",
                    required: ""
                  }, null, 8, ["class", "minDate", "onDateSelect", "modelValue"]),
                  _createVNode("span", _hoisted_39, [
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('promo.toDate')) + ":", 1),
                _createVNode("div", _hoisted_43, [
                  _createVNode(_component_Calendar, {
                    ref: "calendar",
                    class: { 'form-controll-multiselect': !_ctx.dateRange.toDate },
                    onDateSelect: _ctx.dateChanged,
                    modelValue: _ctx.dateRange.toDate,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dateRange.toDate = $event)),
                    minDate: _ctx.validDate,
                    selectionMode: "single",
                    dateFormat: "dd/mm/yy",
                    required: ""
                  }, null, 8, ["class", "onDateSelect", "modelValue", "minDate"]),
                  _createVNode("span", _hoisted_44, [
                    _hoisted_45,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_46, [
              (_ctx.promotedType != _ctx.PromotedType.UpperBanner)
                ? (_openBlock(), _createBlock("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      _createVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('promo.description')) + ":", 1),
                      (_ctx.promoProduct.id)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "col-6 mb-1 text-end pop-up-button",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.routeToEdit()))
                          }, [
                            _hoisted_50
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_51, [
                      _withDirectives(_createVNode("textarea", {
                        name: "textArea",
                        id: "extraInfo",
                        class: "bookit-textarea product-textarea resize-off form-control",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.promoProduct.description = $event)),
                        maxlength: "60",
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.substringLength(_ctx.promoProduct.description, 60)))
                      }, "\n                  ", 544), [
                        [_vModelText, _ctx.promoProduct.description]
                      ])
                    ]),
                    _createVNode("span", _hoisted_52, [
                      _createVNode("span", {
                        class: { 'length-limit': _ctx.promoProduct.description?.length > 59 }
                      }, _toDisplayString(_ctx.promoProduct.description?.length ?? 0), 3),
                      _hoisted_53
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode("div", _hoisted_56, [
                      _withDirectives(_createVNode("textarea", {
                        name: "textArea",
                        required: "",
                        id: "extraInfo",
                        class: "bookit-textarea product-textarea resize-off form-control",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.promoProduct.url = $event)),
                        maxlength: "2000",
                        onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.substringLength(_ctx.promoProduct.url, 2000)))
                      }, "\n                  ", 544), [
                        [_vModelText, _ctx.promoProduct.url]
                      ])
                    ]),
                    _createVNode("span", _hoisted_57, [
                      _createVNode("span", {
                        class: { 'length-limit': _ctx.promoProduct.url?.length > 1999 }
                      }, _toDisplayString(_ctx.promoProduct.url?.length ?? 0), 3),
                      _hoisted_58
                    ])
                  ]))
            ]),
            _createVNode("div", _hoisted_59, [
              _createVNode("div", {
                class: [_ctx.PromotedType[_ctx.promotedType] === 'UpperBanner' || _ctx.PromotedType[_ctx.promotedType] === 'MiddleBanner' || _ctx.PromotedType[_ctx.promotedType] === 'BottomBanner' ? 'col-md-8' : 'col-md-12']
              }, [
                _createVNode("div", _hoisted_60, [
                  _createVNode("div", {
                    class: ["flex-grow-1 d-flex", { 'justify-content-center': !_ctx.promoImage && !_ctx.promoProduct.imagePath }]
                  }, [
                    (_ctx.promoImage || _ctx.promoProduct.imagePath)
                      ? (_openBlock(), _createBlock("div", _hoisted_61, [
                          _createVNode("img", {
                            class: "promo-image",
                            style: {"max-width":"90%"},
                            height: "108",
                            src: _ctx.promoImage || _ctx.promoProduct.imageToShow,
                            alt: ""
                          }, null, 8, ["src"]),
                          _createVNode("i", {
                            class: "icon-f icon-delete-cross fs-12 px-2 py-1 align-self-start",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearImage(false)))
                          }),
                          _createVNode("i", {
                            class: "icon-f icon-pencil-edit fs-12 py-1 align-self-start",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$refs.file.click()))
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode("label", _hoisted_62, [
                      _createVNode("p", _hoisted_63, _toDisplayString(_ctx.$t('product-banner.optional-image-size')), 1),
                      _createVNode("input", {
                        ref: "file",
                        type: "file",
                        name: "",
                        id: "image-upload-input",
                        style: {"display":"none"},
                        onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.uploadingImageValidation($event, false))),
                        accept: "image/*"
                      }, null, 544),
                      _createVNode("img", {
                        class: ["pointer", { 'png-red': _ctx.validated && !_ctx.promoProduct.image }],
                        src: _imports_0
                      }, null, 2),
                      _createVNode("div", {
                        class: ["text-link py-1", { 'color-red': _ctx.validated && !_ctx.promoProduct.image }]
                      }, _toDisplayString(_ctx.$t('link.upload-image')), 3)
                    ], 512), [
                      [_vShow, !_ctx.promoImage && !_ctx.promoProduct.imagePath]
                    ])
                  ], 2)
                ])
              ], 2),
              (_ctx.PromotedType[_ctx.promotedType] === 'UpperBanner' || _ctx.PromotedType[_ctx.promotedType] === 'MiddleBanner' || _ctx.PromotedType[_ctx.promotedType] === 'BottomBanner')
                ? (_openBlock(), _createBlock("div", _hoisted_64, [
                    _createVNode("div", _hoisted_65, [
                      _createVNode("div", {
                        class: ["flex-grow-1 d-flex", { 'justify-content-center': !_ctx.promoImageMobile && !_ctx.promoProduct.mobileImagePath }]
                      }, [
                        (_ctx.promoImageMobile || _ctx.promoProduct.mobileImagePath)
                          ? (_openBlock(), _createBlock("div", _hoisted_66, [
                              _createVNode("img", {
                                class: "promo-image",
                                style: {"max-width":"90%"},
                                height: "108",
                                src: _ctx.promoImageMobile || _ctx.promoProduct.mobileImageToShow,
                                alt: ""
                              }, null, 8, ["src"]),
                              _createVNode("i", {
                                class: "icon-f icon-delete-cross fs-12 px-2 py-1 align-self-start",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearImage(true)))
                              }),
                              _createVNode("i", {
                                class: "icon-f icon-pencil-edit fs-12 py-1 align-self-start",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$refs.mobileFile.click()))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _withDirectives(_createVNode("label", _hoisted_67, [
                          _createVNode("p", _hoisted_68, _toDisplayString(_ctx.$t('product-banner.optional-mobile-image-size')), 1),
                          _createVNode("input", {
                            ref: "mobileFile",
                            type: "file",
                            name: "",
                            id: "image-upload-input",
                            style: {"display":"none"},
                            onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.uploadingImageValidation($event, true))),
                            accept: "image/*"
                          }, null, 544),
                          _createVNode("img", {
                            class: ["pointer", { 'png-red': _ctx.mobileValidated && !_ctx.promoProduct.mobileImage }],
                            src: _imports_0
                          }, null, 2),
                          _createVNode("div", {
                            class: ["text-link py-1", { 'color-red': _ctx.mobileValidated && !_ctx.promoProduct.mobileImage }]
                          }, _toDisplayString(_ctx.$t('link.upload-image')), 3)
                        ], 512), [
                          [_vShow, !_ctx.promoImageMobile && !_ctx.promoProduct.mobileImagePath]
                        ])
                      ], 2)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ], 32),
    _hoisted_69,
    _createVNode("div", _hoisted_70, [
      _createVNode("div", _hoisted_71, [
        _createVNode("div", _hoisted_72, [
          _createVNode("button", {
            type: "button",
            class: "order-modify-button-wrapper dark-circle-button",
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
          }, _toDisplayString(_ctx.$t('button.cancel')), 1)
        ]),
        _createVNode("div", _hoisted_73, [
          _createVNode("button", _hoisted_74, [
            _hoisted_75,
            _createVNode("div", _hoisted_76, _toDisplayString(_ctx.$t('button.save')), 1)
          ])
        ])
      ]),
      (_ctx.promoProduct.order)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "arrow-button",
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
            type: "button"
          }, [
            _hoisted_77
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})